import {
  Body1,
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Field,
  Input,
  makeStyles,
  Textarea,
} from "@fluentui/react-components";
import {
  Dismiss16Regular,
  Dismiss24Regular,
  Send24Filled,
} from "@fluentui/react-icons";
import UploadIcon from "../../../../assets/uploadicon.svg";
import React, { useState } from "react";
import FormikInputRequest from "../../../../service/hook/useFormik";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../redux/store";
import Dropzone from "react-dropzone";
import moment from "moment";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchCustomerMessages,
  postMessage,
} from "../../../../redux/clientPortal/clientPortalslice";

const useStyles = makeStyles({
  dialogContent: {
    // border: "1px solid #ddd",
    padding: "10px",
    borderRadius: "4px",
  },
  attachmentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
  },
  chip: {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    fontSize: "14px",
    color: "#616161",
    gap: "5px",
  },
});
function SendFile({ open, onClose, customerId, notify }: any) {
  const styles = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const [actionProcessing, setActionProcessing] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD/MM/YYYY");
  };
  const removeFile = () => {
    setUploadedFiles([]);
    formikData.setFieldValue("file", "");
  };
  const formikData = FormikInputRequest({
    initialValues: {
      subject: "",
      date: new Date(),
      message: "",
      file: "",
    },
    validate: (values) => {
      const errors: any = {};
      // if (values.subject.length > 256) {
      //   errors.subject = "File Name cannot be longer than 256 characters";
      // }
      if (values.message && values.message.length > 5000) {
        errors.message = "Description cannot be longer than 5000 characters";
      }
      if (!values.file) {
        errors.file = "File is required";
      }
      return errors;
    },
    onSubmitFn: async (values: any) => {
      const { subject, date, message, file } = values;
      setActionProcessing(true);

      try {
        await dispatch(
          postMessage({
            customer_id: customerId,
            subject,
            message,
            sent_by_ifa: 1,
            isdocument_message: 1,
            file: file,
          })
        ).then((res) => {

          notify(res.payload.message, "", "success");
          formikData.resetForm();
          if (customerId) {
            dispatch(fetchCustomerMessages({ customerId }));
          }
          setActionProcessing(false);
          setUploadedFiles([]);
          onClose();
        });
      } catch (error: any) {
        notify(error, "", "error");
        setActionProcessing(false);

        //   showSnackbar(error, "error");
      }
    },
  });
  return (
    <Dialog open={open} modalType="modal">
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button
                  appearance="subtle"
                  aria-label="close"
                  icon={
                    <Dismiss24Regular
                      onClick={() => {
                        formikData.resetForm();
                        removeFile();
                        onClose();
                      }}
                    />
                  }
                />
              </DialogTrigger>
            }
          >
            Send File
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <Field
              label={
                <span>
                  Upload File
                  {formikData.errors.file ? (
                    <span className="required-item">*</span>
                  ) : null}
                </span>
              }
              validationState={formikData.errors.file ? "error" : "none"}
              validationMessage={`${formikData?.errors?.file || ""}`}
            >
              <Dropzone
                onDrop={(acceptedFiles: File[]) => {
                  setUploadedFiles([]);
                  if (acceptedFiles.length > 0) {
                    const file = acceptedFiles[0];
                    setUploadedFiles([...acceptedFiles]);
                    formikData.setFieldValue("file", file);
                  }
                }}
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section className="container">
                    <div
                      {...getRootProps({ className: "dropzone" })}
                      className="file-drop"
                      style={{
                        textAlign: "center",
                        border: "2px dashed #cdcdcd",
                        transition: "border 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.border = "2px dashed #000000a6")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.border = "2px dashed #cdcdcd")
                      }
                    >
                      <input {...getInputProps()} />
                      <img src={UploadIcon} width="50px" />
                      <p style={{ textAlign: "center" }}>
                        Click or Drag the file here to upload
                      </p>
                    </div>
                  </section>
                )}
              </Dropzone>
            </Field>
            <div className="justify_between">
              {uploadedFiles.map((file: any, index: any) => (
                <div className="list-upload-item" key={index}>
                  {file.name} - {(file.size / 1024).toFixed(2)} KB
                  <Dismiss16Regular onClick={() => removeFile()} />
                </div>
              ))}
            </div>
            <Field
              label="File Name"
              validationState={formikData.errors.subject ? "error" : "none"}
              validationMessage={`${formikData?.errors?.subject || ""}`}
            >
              <Input
                type="text"
                name="subject"
                value={formikData.values.subject}
                onChange={formikData.handleChange}
              />
            </Field>
            {/* <Field
              label="Date"
              validationState={formikData.errors.date ? "error" : "none"}
              validationMessage={`${formikData?.errors?.date || ""}`}
            >
              <DatePicker
                name="date"
                value={formikData.values.date}
                formatDate={onFormatDate}
                onSelectDate={(date) => formikData.handleChange}
                disabled // Disable the date picker
              />
            </Field> */}
            <Field
              label="Description"
              validationState={formikData.errors.message ? "error" : "none"}
              validationMessage={`${formikData?.errors?.message || ""}`}
            >
              <Textarea
                name="message"
                rows={5}
                value={formikData.values.message}
                onChange={formikData.handleChange}
              />
            </Field>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 10,
                margin: "10px 0",
              }}
            >
              <Button
                appearance="primary"
                className="asc-button-primary"
                icon={<Send24Filled />}

                disabled={
                  actionProcessing || Object.keys(formikData.errors).length > 0
                }

                onClick={() => formikData.handleSubmit()}
              >
                {actionProcessing ? "Sending..." : "Send"}
              </Button>
              <Button onClick={() => onClose()}>Cancel</Button>
            </div>
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default SendFile;
